import chat from './chat.json';
import config from './config.json';
import deleteAccount from './deleteAccount.json';

export const faqDeleteAccount = {
  chat,
  config,
  deleteAccount,
};
